import React, { useState, useRef, useEffect, createRef } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Layout from "../../components/layout"
import "./styles.scss"

import ArrowSvg from "../../images/arrow-right.svg"

import PlusIcon from "../../images/plus-icon.svg"
import MinusIcon from "../../images/minus-icon.svg"

import Carousel from "@brainhubeu/react-carousel"
import "@brainhubeu/react-carousel/lib/style.css"

import ModalVideo from "react-modal-video"
import "react-modal-video/scss/modal-video.scss"

import BackArrow from "../../images/back-arrow.svg"
import NextArrow from "../../images/next-arrow.svg"

const PricingPage = () => {
  const [isOpen, setOpen] = useState(false)
  const [isOpenAdv, setOpenAdv] = useState(false)
  const [isAdvisory, setAdvisory] = useState(false)
  const [expandedAccor, setExpandedAccor] = useState(0)
  const [expandedHeight, setExpandedHeight] = useState(0)
  const [numClients, setNumClients] = useState(49)
  const [minFaqs, setMinFaqs] = useState(true)

  const customerSliderRef = useRef(null)
  const [customerSlide, setCustomerSlide] = useState(0)

  const query = graphql`
    {
      wp {
        page(id: "/pricing", idType: URI) {
          pricingPage {
            mainHeading
            mainSubheading
            mainToggleLeft
            mainToggleRight
            mainAdvisors {
              appsContent
              appsHeading
              appsImg {
                altText
                sourceUrl
              }
              appsLabel
              appsLink {
                target
                title
                url
              }
              content
              img {
                altText
                sourceUrl
              }
              customerTestimonials {
                image {
                  altText
                  sourceUrl
                }
                name
                quote
                role
              }
              customersHeading
              faqContent
              faqHeading
              faqQuestions {
                a
                q
              }
              heading
              leftButton {
                target
                title
                url
              }
              pricingButton {
                target
                title
                url
              }
              pricingContent
              pricingHeading
              pricingInputHeading
              pricingPriceHeading
              pricingPriceSubheading
              pricingPriceText
              rightButton {
                target
                title
                url
              }
              smallText
              xeroContent
              xeroHeading
              xeroImg {
                altText
                sourceUrl
              }
              xeroLink {
                target
                title
                url
              }
            }
            mainOwners {
              appsContent
              appsHeading
              appsImg {
                altText
                sourceUrl
              }
              appsLabel
              appsLink {
                target
                title
                url
              }
              boxHeading
              content
              customerTestimonials {
                image {
                  altText
                  sourceUrl
                }
                name
                quote
                role
              }
              customersHeading
              faqContent
              faqHeading
              faqQuestions {
                a
                q
              }
              heading
              leftButton {
                target
                title
                url
              }
              list {
                text
              }
              price
              rightButton {
                target
                title
                url
              }
              videoButton {
                target
                title
                url
              }
              videoContent
              videoHeading
              videoImg {
                altText
                sourceUrl
              }
              videoLabel
            }
          }
        }
      }
    }
  `
  const wpdata = useStaticQuery(query)

  const data = wpdata.wp.page.pricingPage

  const toggleData = isAdvisory ? data.mainAdvisors : data.mainOwners
  const advisoryData = data.mainAdvisors
  const ownersData = data.mainOwners

  const [faqs, setFaqs] = useState([])

  let refs = React.useRef([])

  const moveSlider = (ref, direction, slideValue, setSlideValue) => {
    const track = ref.current.querySelector("ul")
    const childrenLen = track.children.length

    if (direction === "next" && slideValue < childrenLen) {
      setSlideValue(slideValue + 1)
    }

    if (direction === "prev" && slideValue >= 1) {
      setSlideValue(slideValue - 1)
    }
  }

  useEffect(() => {
    setFaqs(toggleData.faqQuestions.map((x, i) => ({ ...x, id: i })))
    refs.current = toggleData.faqQuestions.map(
      (_, i) => refs.current[i] ?? createRef()
    )
    setTimeout(() => {
      setExpandedHeight(refs.current[0].current.clientHeight)
    }, 350)
    //eslint-disable-next-line
  }, [toggleData.faqQuestions])

  const format = (num, decimals) =>
    num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })

  return (
    <Layout className="pricing">
      <div className="toggle-section bg-grey text-center py-20">
        <div className="container">
          <h1 className="mt-0 mb-3">{data.mainHeading}</h1>
          <p className="font-md">{data.mainSubheading}</p>
          <div className="toggle-btns mx-auto flex flex-center mt-15">
            {/* eslint-disable-next-line */}
            <div
              className={isAdvisory ? "active" : ""}
              onClick={() => setAdvisory(true)}
              role="button"
            >
              {data.mainToggleLeft}
            </div>
            {/* eslint-disable-next-line */}
            <div
              className={!isAdvisory ? "active" : ""}
              onClick={() => setAdvisory(false)}
              role="button"
            >
              {data.mainToggleRight}
            </div>
          </div>

          <div
            className={`flex mt-18 text-left flex-center ${
              isAdvisory ? "advisory" : "business-owners"
            }`}
          >
            <div className="w-full left-content flex-col flex-center">
              <h2 className="mb-8">{toggleData.heading}</h2>
              <p className={`mb-${isAdvisory ? "19" : "14"}`}>
                {toggleData.content}
              </p>
              <div className={`w-full flex ${isAdvisory && "advisory"}`}>
                <a
                  href={toggleData.leftButton.url}
                  target={toggleData.leftButton.target}
                  className="btn btn-blue"
                >
                  {toggleData.leftButton.title}
                </a>
                <a
                  href={toggleData.rightButton.url}
                  target={toggleData.rightButton.target}
                  className="btn btn-white ml-5"
                >
                  {toggleData.rightButton.title}
                </a>
                {isAdvisory && (
                  <p
                    className="text-center mt-5 hidden font-sm"
                    dangerouslySetInnerHTML={{
                      __html: advisoryData.smallText,
                    }}
                  ></p>
                )}
              </div>
            </div>
            <div className="w-full text-center">
              {isAdvisory ? (
                <>
                  <img
                    className="graph"
                    src={advisoryData.img.sourceUrl}
                    alt={advisoryData.img.altText}
                  />
                  <p
                    className="text-center"
                    dangerouslySetInnerHTML={{
                      __html: advisoryData.smallText,
                    }}
                  ></p>
                </>
              ) : (
                <div className="rounded-3 overflow-hidden mx-auto">
                  <div className="text-white bg-blue font-lg font-normal py-5 uppercase px-13">
                    {ownersData.boxHeading}
                  </div>
                  <div className="px-13 py-15 bg-white flex-col flex-center">
                    <p className="font-sm text-black price font-normal mb-4">
                      <span className="font-bold text-blue">
                        {toggleData.price}
                      </span>{" "}
                      / month
                    </p>
                    <ul className="text-left">
                      {toggleData.list.map((v, i) => (
                        <li key={i}>{v.text}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {isAdvisory && (
        <div className="pricing-section bg-blue text-white">
          <div className="container flex py-20">
            <div className="w-full flex flex-col flex-center text-left">
              <h2 className="font-normal">{advisoryData.pricingHeading}</h2>
              <p>{advisoryData.pricingContent}</p>

              <ModalVideo
                channel="youtube"
                autoplay
                isOpen={isOpenAdv}
                videoId={
                  advisoryData.pricingButton.url.includes("watch?v=")
                    ? advisoryData.pricingButton.url
                        .split("watch?v=")
                        .reverse()[0]
                    : advisoryData.pricingButton.url.split("/").reverse()[0]
                }
                onClose={() => setOpenAdv(false)}
              />

              <button
                onClick={() => setOpenAdv(true)}
                className="btn inline-flex mt-14 flex-center"
              >
                {advisoryData.pricingButton.title}{" "}
                <span className="ml-2 inline-block right-arrow"></span>
              </button>
            </div>
            <div className="w-full">
              <div className="price-box bg-white rounded-3 text-navy text-center font-normal mx-auto">
                <div className="px-15 pt-15 pb-9">
                  <p>{advisoryData.pricingInputHeading}</p>
                  <div className="input">
                    <input
                      value={numClients}
                      onChange={e => {
                        let numInput = Number(e.target.value)

                        if (!numInput) {
                          return setNumClients(0)
                        }

                        if (numInput > 250) return setNumClients(250)

                        return setNumClients(numInput)
                      }}
                      className="text-blue text-center font-bold p-0 pr-9"
                    />
                    {/* eslint-disable-next-line */}
                    <span
                      onClick={() => {
                        if (numClients >= 250) return
                        setNumClients(numClients + 1)
                      }}
                      role="button"
                    ></span>
                    {/* eslint-disable-next-line */}
                    <span
                      role="button"
                      onClick={() => {
                        if (!numClients) return
                        setNumClients(numClients - 1)
                      }}
                    ></span>
                  </div>
                </div>
                <div className="px-15 pt-15 pb-9 bg-grey">
                  <p>{advisoryData.pricingPriceHeading}</p>
                  <p className="price">
                    <span className="font-bold">
                      ${numClients <= 5 ? 0 : format(numClients * 9.99, 2)}
                    </span>{" "}
                    {advisoryData.pricingPriceText}
                  </p>
                  <p>{advisoryData.pricingPriceSubheading}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {!isAdvisory && (
        <div className="video-section container flex flex-center pt-20">
          <div className="w-full">
            <h4>{ownersData.videoLabel}</h4>
            <h2 className="mb-10">{ownersData.videoHeading}</h2>
            <p className="mb-10">{ownersData.videoContent}</p>
            <ModalVideo
              channel="youtube"
              autoplay
              isOpen={isOpen}
              videoId={
                ownersData.videoButton.url.includes("watch?v=")
                  ? ownersData.videoButton.url.split("watch?v=").reverse()[0]
                  : ownersData.videoButton.url.split("/").reverse()[0]
              }
              onClose={() => setOpen(false)}
            />

            <button onClick={() => setOpen(true)} className="btn inline-block">
              {ownersData.videoButton.title}{" "}
              <span className="ml-2 inline-block right-arrow"></span>
            </button>
          </div>
          <div className="w-full">
            <img
              src={ownersData.videoImg.sourceUrl}
              alt={ownersData.videoImg.altText}
            />
          </div>
        </div>
      )}

      <div className="connect-apps-section py-20">
        <div className="container flex">
          <div className="w-full text-left pr-12 box-border">
            <img
              className="app-image"
              alt={toggleData.appsImg.altText}
              src={toggleData.appsImg.sourceUrl}
            />
          </div>
          <div className="w-full my-auto mr-2">
            <h4>{toggleData.appsLabel}</h4>
            <h2 className="text-left">{toggleData.appsHeading}</h2>
            <p>{toggleData.appsContent}</p>
            {/* <a
                    className="get-started mt-12 inline-flex flex-center text-blue font-bold font-md"
                    href={toggleData.appsLink.url}
                    target={toggleData.appsLink.target}
                  >
                    {toggleData.appsLink.title} <ArrowSvg className="ml-3" />
                  </a> */}
          </div>
        </div>
      </div>

      {isAdvisory && (
        <div className="xero-section pt-15 pb-20 container text-center">
          <div className="container">
            <img
              className="xero-image"
              src={advisoryData.xeroImg.sourceUrl}
              alt={advisoryData.xeroImg.altText}
            />
            <h4 className="mt-14 mb-3">{advisoryData.xeroLabel}</h4>

            <h2 className="text-center mb-8">{advisoryData.xeroHeading}</h2>
            <p>{advisoryData.xeroContent}</p>
            <a
              className="get-started mt-12 inline-flex flex-center text-blue font-bold font-md"
              href={toggleData.xeroLink.url}
              target={toggleData.xeroLink.target}
            >
              {toggleData.xeroLink.title} <ArrowSvg className="ml-3" />
            </a>
          </div>
        </div>
      )}

      <div className="faq-section bg-grey mt-17 py-20 text-center">
        <div className="container">
          <h2 className="mb-3">{toggleData.faqHeading}</h2>
          <p>{toggleData.faqContent}</p>

          <div className="accordians mx-auto mt-19">
            {faqs.slice(0, minFaqs ? 4 : faqs.length).map(item => {
              return (
                <div className="item mb-3" key={item.id}>
                  {/* eslint-disable-next-line */}
                  <div
                    role="button"
                    className="bg-white p-14 flex flex-center question"
                    onClick={() => {
                      setExpandedHeight(
                        refs.current[item.id].current.clientHeight
                      )
                      if (item.id === expandedAccor) {
                        return setExpandedAccor(false)
                      }
                      setExpandedAccor(item.id)
                    }}
                  >
                    <p className="font-normal mb-0 text-left pr-12">{item.q}</p>

                    {expandedAccor === item.id ? (
                      <MinusIcon className="ml-auto" />
                    ) : (
                      <PlusIcon className="ml-auto" />
                    )}
                  </div>
                  <div
                    className="answer"
                    style={{
                      height: `${
                        expandedAccor === item.id ? expandedHeight : 0
                      }px`,
                    }}
                  >
                    <p
                      className="py-11 px-8 text-left mb-0"
                      role={item.id}
                      ref={refs.current[item.id]}
                    >
                      {item.a}
                    </p>
                  </div>
                </div>
              )
            })}
          </div>

          {/* eslint-disable-next-line */}
          <span
            className="accord-more flex flex-center mx-auto p-5 text-blue font-bold"
            onClick={() => setMinFaqs(!minFaqs)}
          >
            {!minFaqs ? (
              <>
                <MinusIcon className="mr-2" /> {"View less"}
              </>
            ) : (
              <>
                <PlusIcon className="mr-2" /> {"View more"}
              </>
            )}
          </span>
        </div>
      </div>

      <div className="customers-say-section">
        <div className="container">
          <h2 className="text-center">{toggleData.customersHeading}</h2>

          <div className="customers-slider" ref={customerSliderRef}>
            <Carousel
              slidesPerPage={3}
              offset={0}
              value={customerSlide}
              onChange={value => customerSlide}
              breakpoints={{
                768: {
                  slidesPerPage: 2,
                },
                600: {
                  slidesPerPage: 1,
                },
              }}
            >
              {toggleData.customerTestimonials.map((customer, i) => {
                return (
                  <div key={i} className="slide">
                    <div>
                      <div className="flex">
                        <img
                          src={customer.image.sourceUrl}
                          alt={customer.image.altText}
                        />
                        <div>
                          <p>{customer.role}</p>
                          <p>{customer.name}</p>
                        </div>
                      </div>
                      <p>{customer.quote}</p>
                    </div>
                  </div>
                )
              })}
            </Carousel>
            <div className="arrows">
              <BackArrow
                className="mr-9"
                onClick={() => {
                  moveSlider(
                    customerSliderRef,
                    "prev",
                    customerSlide,
                    setCustomerSlide
                  )
                }}
              />
              <NextArrow
                onClick={() => {
                  moveSlider(
                    customerSliderRef,
                    "next",
                    customerSlide,
                    setCustomerSlide
                  )
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default PricingPage
